import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { brand, fonts } from '../brand'

const navLinkStyle = {
  fontFamily: fonts.body,
  fontSize: 14,
  fontWeight: 500,
  color: brand.slate,
} as const

/**
 * Cabeçalho da landing na identidade Codout: base clara frosted, wordmark tinta e a tag
 * "PRODUTO CODOUT · SAAS" em mono (Codout.Support é um Produto Codout · SaaS). Signup em pílula
 * tinta, como os CTAs do codout.com.
 */
export function LandingHeader() {
  const { t } = useTranslation()

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        backdropFilter: 'blur(14px)',
        background: 'rgba(244, 247, 250, 0.82)',
        borderBottom: `1px solid ${brand.line}`,
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '0 24px',
          height: 64,
          display: 'flex',
          alignItems: 'center',
          gap: 20,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div
            style={{
              width: 26,
              height: 26,
              borderRadius: 7,
              background: brand.ink,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: 13,
            }}
            aria-hidden="true"
          >
            {t('landing.brand.mark')}
          </div>
          <span
            style={{
              fontFamily: fonts.display,
              fontSize: 15,
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: brand.ink,
            }}
          >
            {t('productName')}
          </span>
          <span
            className="hidden lg:inline-flex"
            style={{
              alignItems: 'center',
              fontFamily: fonts.mono,
              fontSize: 10.5,
              fontWeight: 500,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: brand.signalDeep,
              paddingLeft: 12,
              marginLeft: 2,
              borderLeft: `1px solid ${brand.line}`,
            }}
          >
            {t('landing.brand.productTag')}
          </span>
        </div>

        <nav className="hidden items-center gap-[22px] md:flex">
          <a href="#produto" style={navLinkStyle}>
            {t('landing.nav.produto')}
          </a>
          <a href="#como" style={navLinkStyle}>
            {t('landing.nav.como')}
          </a>
          <a href="#controle" style={navLinkStyle}>
            {t('landing.nav.controle')}
          </a>
          <a href="#planos" style={navLinkStyle}>
            {t('landing.nav.planos')}
          </a>
          <a href="#duvidas" style={navLinkStyle}>
            {t('landing.nav.duvidas')}
          </a>
        </nav>

        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Link
            to="/login"
            style={{
              fontFamily: fonts.body,
              fontSize: 14,
              fontWeight: 500,
              padding: '8px 14px',
              borderRadius: 100,
              color: brand.ink,
            }}
          >
            {t('landing.nav.login')}
          </Link>
          <Link
            to="/signup"
            style={{
              fontFamily: fonts.display,
              fontSize: 14,
              fontWeight: 500,
              padding: '9px 18px',
              borderRadius: 100,
              background: brand.ink,
              color: '#fff',
            }}
          >
            {t('landing.nav.signup')}
          </Link>
        </div>
      </div>
    </header>
  )
}
